export const env = '%DETECTED_ENV%'
